import type { SessionLapMarker } from "@/utils/lapTimeline";

interface TimelineLapMarkersProps {
  markers: SessionLapMarker[];
  /** Maps session time to a CSS `left` percentage string. */
  getPointPosition: (sessionTime: number) => string;
  buildAriaLabel: (marker: SessionLapMarker) => string;
  onLapClick?: (marker: SessionLapMarker) => void;
}

/**
 * Green start/finish crossing markers with lap-number badges for the video
 * timelines. Clicking a marker seeks the shared session cursor to the
 * crossing, which lets the synced player jump to that lap.
 */
export function TimelineLapMarkers({
  markers,
  getPointPosition,
  buildAriaLabel,
  onLapClick,
}: TimelineLapMarkersProps) {
  return (
    <>
      {markers.map((marker) => (
        <button
          key={marker.lap.lapNumber}
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            onLapClick?.(marker);
          }}
          className={`group pointer-events-auto absolute inset-y-0 z-20 w-2.5 -translate-x-1/2 ${
            marker.lap.isValid === false ? "opacity-60" : ""
          }`}
          style={{ left: getPointPosition(marker.sessionTime) }}
          title={buildAriaLabel(marker)}
          aria-label={buildAriaLabel(marker)}
        >
          <span
            aria-hidden="true"
            className="absolute inset-y-1.5 left-1/2 w-px -translate-x-1/2 bg-[#4ade80]/75 group-hover:bg-[#4ade80]"
          />
          <span
            aria-hidden="true"
            className="absolute bottom-1 left-1/2 -translate-x-1/2 rounded-[2px] border border-[#4ade80]/80 bg-[#052e16] px-0.5 text-[8px] font-bold leading-[10px] text-[#4ade80] tabular-nums"
          >
            {marker.lap.lapNumber}
          </span>
        </button>
      ))}
    </>
  );
}
